module.exports = __webpack_public_path__ + "static/media/ppt.e8f28ab5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/scenes/Files/images/ppt.svg
// module id = 604
// module chunks = 0